import { Box, Camera, type LucideIcon } from 'lucide-react'
import type { ModelKind } from 'types'

import type { ThreeDModelRow } from './buildThreeDModelRows'

export const MODEL_KIND_LABEL: Record<ModelKind, string> = {
  walkthrough: 'Walkthrough',
  birdsView: 'Drone Scan',
}

export const MODEL_KIND_ICON: Record<ModelKind, LucideIcon> = {
  walkthrough: Camera,
  birdsView: Box,
}

export const hasModelKind = (row: ThreeDModelRow, kind: ModelKind): boolean =>
  kind === 'walkthrough'
    ? row.matterportSpaceId !== undefined
    : row.systemViewUnitId !== undefined

export const defaultModelKindFor = (row: ThreeDModelRow): ModelKind =>
  row.matterportSpaceId ? 'walkthrough' : 'birdsView'
